import type { IssueDisplayStatus } from '@cortex/domain-ac-mens-hub-api';
import { Badge } from '@cortex/web-design-system/components/ui/Badge';
import { useTranslation } from 'react-i18next';

import { ISSUE_STATUS_LABEL_KEYS, ISSUE_STATUS_VARIANTS } from '../../lib/issue-mgmt-format.js';

/**
 * 課題の見せる状態の札（判定待ち＝黄・対応中＝藍・解決済み＝緑・保留と対応しない＝灰）。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題の見せる5つの状態を、色の決まった札で表示する
 * @graph-connects ISSUE_STATUS_LABEL_KEYS [references] 状態の文言
 * @graph-connects ISSUE_STATUS_VARIANTS [references] 状態の色
 */
export function IssueStatusBadge({ status }: { status: IssueDisplayStatus }) {
  const { t } = useTranslation();
  return (
    <Badge variant={ISSUE_STATUS_VARIANTS[status]}>{t(ISSUE_STATUS_LABEL_KEYS[status])}</Badge>
  );
}
